import React from 'react';
import PropTypes from 'prop-types';
import spinner from 'assets/spinner.svg';
import styles from './styles.module.css';

const Spinner = ({ text }) => (
  <div className={styles.spinner}>
    <div className={styles.spinnerImage}>
      <img src={spinner} alt="Loading spinner" />
    </div>
    <div className={styles.spinnerText}>{text}</div>
  </div>
);

Spinner.propTypes = {
  text: PropTypes.string,
};

Spinner.defaultProps = {
  text: 'Loading...',
};

export default Spinner;
